import React, { useState, useEffect } from 'react';
import 'react-phone-number-input/style.css';

import Navbar from './Navbar';
import '../style/global.scss';
import { navigate } from 'gatsby';
import { BuilderNav } from '../components/ideabuilder/BuilderNav';

const AppLayout = ({ children }) => {
    const [isBuilderMode, setIsBuilderMode] = useState(false);
    const isBrowser = typeof window !== 'undefined';

    useEffect(() => {
        if (!isBrowser) return;

        if (!localStorage.builderMode) return;

        if (JSON.parse(localStorage.builderMode)) {
            setIsBuilderMode(true);
            navigate('/builder');
        } else {
            setIsBuilderMode(false);
        }
    }, [isBrowser]);

    return (
        <>
            {isBuilderMode ? <BuilderNav /> : <Navbar />}
            <div
                // ref={scrollContainer}
                className="main_container"
            >
                {children}
            </div>
        </>
    );
};

export default AppLayout;
